import React from 'react';

interface RecurrenceSelector {
  value: {
    frequency: 'daily' | 'weekly' | 'monthly';
    interval: number;
  } | null;
  onChange: (value: { frequency: 'daily' | 'weekly' | 'monthly'; interval: number; } | null) => void;
}

export default function RecurrenceSelector({ value, onChange }: RecurrenceSelector) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Recorrência
      </label>
      <div className="space-y-3">
        <select
          value={value?.frequency || 'none'}
          onChange={(e) => {
            if (e.target.value === 'none') {
              onChange(null);
            } else {
              onChange({
                frequency: e.target.value as 'daily' | 'weekly' | 'monthly',
                interval: 1
              });
            }
          }}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-600 focus:border-transparent"
        >
          <option value="none">Sem recorrência</option>
          <option value="daily">Diariamente</option>
          <option value="weekly">Semanalmente</option>
          <option value="monthly">Mensalmente</option>
        </select>

        {value && (
          <div className="flex items-center space-x-2">
            <span className="text-sm text-gray-600">Repetir a cada</span>
            <input
              type="number"
              min="1"
              value={value.interval}
              onChange={(e) => onChange({ 
                ...value, 
                interval: Math.max(1, parseInt(e.target.value) || 1)
              })}
              className="w-20 px-2 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-600 focus:border-transparent"
            />
            <span className="text-sm text-gray-600">
              {value.frequency === 'daily' && 'dias'}
              {value.frequency === 'weekly' && 'semanas'}
              {value.frequency === 'monthly' && 'meses'}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}